module.exports = __webpack_public_path__ + "static/media/wildlife.074189e9.png";